tiz.config([
  "$httpProvider",
  function ($httpProvider) {
    var requestInterceptor = function ($q, $rootScope, $injector) {
      function shouldIgnore(config) {
        return (
          config.url.startsWith("/api/retailer/job_statuses") ||
          config.url.includes("/recommendations") ||
          config.url.startsWith("/api/retailer/product_lines/available_filters")
        );
      }
      $rootScope.submissionInProgress = false;
      $rootScope.showLoading = false;
      $rootScope.pendingRequests = 0;

      var turnOffModal = function (error) {
        $rootScope.pendingRequests--;
        if ($rootScope.pendingRequests <= 0) {
          $rootScope.showLoading = false;
          $rootScope.pendingRequests = 0;
        }
      };

      return {
        request: function (config) {
          if (config.method === "GET") {
            if (!shouldIgnore(config)) {
              $rootScope.pendingRequests++;
              if (!$rootScope.showLoading) {
                $rootScope.showLoading = true;
              }
              $rootScope.showLoading = true;
            }
          }
          return config || $q.when(config);
        },

        requestError: function (rejection) {
          if ((rejection.config || {}).method === "GET") {
            turnOffModal("request-error");
          }
          return $q.reject(rejection);
        },

        response: function (response) {
          if ((response.config || {}).method === "GET") {
            turnOffModal();
          }
          return $q.when(response);
        },

        responseError: function (rejection) {
          if ((rejection.config || {}).method === "GET") {
            turnOffModal("response-error");
          }
          return $q.reject(rejection);
        },
      };
    };

    requestInterceptor.$inject = ["$q", "$rootScope", "$injector"];
    $httpProvider.interceptors.push(requestInterceptor);
  },
]);
